'use client';

import React, { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { PLCTA } from 'components/performance-lab/PLCTA';
import { useModal } from 'components/shared/Modal';
import { PerformanceLabTFModal } from 'components/performance-lab/WaitlistTypeformModal';
import { SectionWidth } from './atoms';
import styles from './LeaderboardFooter.module.css';

export const LeaderboardFooter: React.FC = () => {
  const t = useTranslations('performance-lab');
  const modal = useModal();

  const openBookTour = useCallback(() => {
    modal.set(
      <PerformanceLabTFModal flow="pl_leaderboard_footer" />,
    );
    modal.setCloseButtonTheme('light');
    modal.show();
  }, [modal]);

  return (
    <SectionWidth
      as="footer"
      className={styles.footer}
      aria-labelledby="leaderboard-footer-title"
    >
      <h2 className={styles.title} id="leaderboard-footer-title">
        {t('leaderboard.footer.title')}
      </h2>
      <p className={styles.copy}>
        {t('leaderboard.footer.description1')}
      </p>
      <p className={styles.copy}>
        {t('leaderboard.footer.description2Lead')}
        <strong>
          {t('leaderboard.footer.description2Bold')}
        </strong>
      </p>
      <PLCTA
        className={styles.footerCta}
        type="button"
        onClick={openBookTour}
        aria-label={t('leaderboard.bookTourCtaAria')}
        data-buttontype="vo2_leaderboard_book_tour"
      >
        {t('leaderboard.bookTourCta')}
      </PLCTA>
    </SectionWidth>
  );
};
